"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withCorrelationId = void 0;
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _objectDestructuringEmpty(obj) { if (obj == null) throw new TypeError("Cannot destructure " + obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); } /*
 * Copyright (c) 2022, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
/**
 * An HOC that injects the correlation id to a component
 * @param Component
 *
 */
const withCorrelationId = Component => {
  const wrappedComponentName = Component.displayName || Component.name;
  const WrappedComponent = _ref => {
    let passThroughProps = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
    const {
      correlationId
    } = (0, _hooks.useCorrelationId)();
    return /*#__PURE__*/_react.default.createElement(Component, _extends({}, passThroughProps, {
      correlationId: correlationId
    }));
  };
  WrappedComponent.displayName = `withCorrelationId(${wrappedComponentName})`;
  return WrappedComponent;
};
exports.withCorrelationId = withCorrelationId;